import { render } from "./StaticContentPage.vue?vue&type=template&id=65ba55f4"
import script from "./StaticContentPage.vue?vue&type=script&lang=js"
export * from "./StaticContentPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__